/**
 * Copyright IBM Corp. 2022, 2026
 */

/**
 * Get a LinkedIn post's URN type and ID from
 * a given URL
 *
 * @param {String} url A LinkedIn post URL to parse
 * @returns An object containing the URN type and post ID in the URL
 */

export function parseLIUrl(url: string) {
	// First get the URL with no search params
	const cleanUrl = new URL(url).pathname

	// Default to blank URN type and id
	let urnType = ''
	let id = ''

	// If the URL has a URN segment(e.g.: `urn:li:`)
	if (cleanUrl.includes('urn:li:')) {
		// Split the URL on `:` to get necessary strings
		const urlParts = cleanUrl.split(':')

		urnType = urlParts[2]
		id = urlParts[3]
	} else {
		// Extract the URN type and ID from the URL text

		// Get the post ID, which always comes after the post type in non-URN-segment URLs
		const parts = cleanUrl.split('-')
		const urnTypeIdx = parts.findIndex((part) => {
			return ['ugcPost', 'activity', 'share'].includes(part)
		})

		if (urnTypeIdx > -1) {
			urnType = parts[urnTypeIdx]
			id = parts[urnTypeIdx + 1] ?? ''
		}
	}

	return {
		urnType,
		id,
	}
}
